import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { api_url } from "../../constant/constant";

const Licensekey = () => {
  const { t } = useTranslation();
  const [license, setLicense] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({});

  const formatDate = (rawDate) => {
    if (!rawDate) return "";
    try {
      const date = new Date(rawDate);
      if (isNaN(date.getTime())) return rawDate;

      return date.toLocaleDateString("en-US", {
        year: "numeric",
        day: "2-digit",
        month: "2-digit",
      });
    } catch {
      return rawDate;
    }
  };

  const fetchLicense = async () => {
    setLoading(true);

    try {
      const token = localStorage.getItem("userToken");
      if (!token) {
        setLoading(false);
        return;
      }

      const response = await fetch(`${api_url}/customer/licenses`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      const licenses = result?.data || [];

      setLicense(licenses);

      const initialFormData = licenses.reduce((acc, item) => {
        acc[item.id] = {
          license_type: item.license_type || "",
          system_license_max_users: item.system_license_max_users || "",
          system_license_start_date: item.system_license_start_date || "",
          system_license_expiration_date: item.system_license_expiration_date || "",
          phishing_license_max_users: item.phishing_license_max_users || "",
          phishing_license_start_date: item.phishing_license_start_date || "",
          phishing_license_expiration_date: item.phishing_license_expiration_date || "",
          is_active: item.is_active || "",
          is_used: item.is_used || "",
        };
        return acc;
      }, {});

      setFormData(initialFormData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLicense();
  }, []);

  if (loading) return <p>{t("Loading")}</p>;
  if (!license || license.length === 0) return <p>{t("NoLicenseDataFound")}</p>;

  return (
    <div>
      <h3>{t("LicenseDetails")}</h3>

      {license.map((item) => (
        <div key={item.id}>
          <div className="row">
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">{t("LicenseType")}</label>
                <input
                  type="text"
                  name="license_type"
                  className="form-control"
                  disabled
                  value={formData[item.id]?.license_type || ""}
                  readOnly
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">{t("SystemLicenseMaxUsers")}</label>
                <input
                  type="text"
                  name="system_license_max_users"
                  className="form-control"
                  disabled
                  value={formData[item.id]?.system_license_max_users || ""}
                  readOnly
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">{t("SystemLicenseStartDate")}</label>
                <input
                  type="text"
                  name="system_license_start_date"
                  className="form-control"
                  disabled
                  readOnly
                  value={formatDate(formData[item.id]?.system_license_start_date)}
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">{t("SystemLicenseExpirationDate")}</label>
                <input
                  type="text"
                  name="system_license_expiration_date"
                  className="form-control"
                  disabled
                  readOnly
                  value={formatDate(formData[item.id]?.system_license_expiration_date)}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">{t("PhishingLicenseMaxUsers")}</label>
                <input
                  type="text"
                  name="phishing_license_max_users"
                  className="form-control"
                  disabled
                  value={formData[item.id]?.phishing_license_max_users || ""}
                  readOnly
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">{t("PhishingLicenseStartDate")}</label>
                <input
                  type="text"
                  name="phishing_license_start_date"
                  className="form-control"
                  disabled
                  readOnly
                  value={formatDate(formData[item.id]?.phishing_license_start_date)}
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">{t("PhishingLicenseExpirationDate")}</label>
                <input
                  type="text"
                  name="phishing_license_expiration_date"
                  className="form-control"
                  disabled
                  readOnly
                  value={formatDate(formData[item.id]?.phishing_license_expiration_date)}
                />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Licensekey;